'use strict';

var base = require('./product/base');

$('body').on('product:updateAvailability', function (e, response) {
    $('div.availability', response.$productContainer)
        .data('ready-to-order', response.product.readyToOrder)
        .data('available', response.product.available);

    $('.product-msg-availability').remove();

    if (!response.product.available) {
        base.outOfStockMessage(response.product.availability.messages[0]);
    }
    if ($('.global-availability').length) {
        var allAvailable = $('.product-availability').toArray()
            .every(function (item) { return $(item).data('available'); });

        var allReady = $('.product-availability').toArray()
            .every(function (item) { return $(item).data('ready-to-order'); });

        $('.global-availability')
            .data('ready-to-order', allReady)
            .data('available', allAvailable);

        $('.global-availability .availability-msg').empty()
            .html(allReady ? response.message : response.resources.info_selectforstock);
    }
});

$(document).on('editwishlistproduct:ready', function(e) {
    var labelSelectSize = $(window).width() < 768 ? $($('.selectpicker').find('option:selected')[1]).hasClass('js-label-select-size') : $($('.selectpicker').find('option:selected')[0]).hasClass('js-label-select-size');
    if ($('.color-attribute.selected').length > 0 && !labelSelectSize) {
        var $productContainer = $(window).width() < 768 ? $($('.product-detail')[1]) : $($('.product-detail')[0]);
        base.attributeSelect($('.color-attribute.selected').data('url'), $productContainer);
    }
    $('.selectpicker').selectpicker();
});



// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/detailWishlist.js